module.exports = __webpack_public_path__ + "static/media/area_32_blue.39a92078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/area_32_blue.svg
// module id = 1371
// module chunks = 0